import styled, { css, keyframes } from 'styled-components';
import { breakpoints } from '@/styles/breakpoints';

const animate1 = keyframes`
  0% {
    opacity: 1;
  }

  25% {
    opacity: 1;
  }

  50% {
    opacity: 0.25;
  }

  100% {
    opacity: 0.25;
  }
`;

const animate2 = keyframes`
  0% {
    opacity: 0.25;
  }

  25% {
    opacity: 1;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0.25;
  }
`;

const animate3 = keyframes`
  0% {
    opacity: 0.25;
  }

  25% {
    opacity: 0.25;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 1;
  }
`;

interface AnimatedLoadingProps {
  small: boolean;
}

const AnimatedLoading = styled.div<AnimatedLoadingProps>`
  display: grid;
  justify-content: center;
  align-items: center;
  height: 40vh;

  ${breakpoints.MD} {
    height: 50vh;
  }

  ${breakpoints.MDL} {
    height: 60vh;
  }

  ${breakpoints.LG} {
    height: 70vh;
  }

  ${breakpoints.XXLG} {
    height: 50vh;
  }

  ${({ small }) =>
    small &&
    css`
      height: 30px !important;
    `}
`;

const Wrapper = styled.div`
  svg {
    animation: 1s linear infinite ${animate1};

    &:nth-child(2) {
      animation: 1s linear infinite ${animate2};
    }

    &:nth-child(3) {
      animation: 1s linear infinite ${animate3};
    }
  }
`;

export { AnimatedLoading, Wrapper };
